import { render, staticRenderFns } from "./PainterUpdates.vue?vue&type=template&id=deb343b6&scoped=true"
import script from "./PainterUpdates.vue?vue&type=script&lang=js"
export * from "./PainterUpdates.vue?vue&type=script&lang=js"
import style0 from "./PainterUpdates.vue?vue&type=style&index=0&id=deb343b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb343b6",
  null
  
)

export default component.exports